import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle2 } from 'lucide-react';
import SEO from '../components/SEO';
import { SERVICES_DATA } from '../data/servicesData'; // We'll extract the data to a shared file

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = SERVICES_DATA.find(s => s.slug === slug);

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  return (
    <div className="pt-16 pb-16 md:pt-20 md:pb-20 bg-grid-white min-h-screen">
      <SEO title={`${service.title} | CodeViora`} description={service.desc} />
      
      <div className="container-max">
        <Link to="/services" className="inline-flex items-center gap-2 text-sm font-medium text-black/50 dark:text-white/50 dark:text-white/50 hover:text-black dark:hover:text-white dark:text-white dark:hover:text-white transition-colors mb-8 mt-8">
          <ArrowLeft size={16} /> Back to Services
        </Link>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-4xl">{service.icon}</span>
              {service.tag && <span className="text-xs font-medium px-3 py-1 rounded-full bg-black dark:bg-white text-white dark:text-black">{service.tag}</span>}
            </div>
            
            <h1 className="text-4xl md:text-5xl font-display font-medium text-black dark:text-white mb-6 leading-tight">
              {service.headline}
            </h1>
            
            <p className="text-lg text-black/70 dark:text-white/70 dark:text-white/70 mb-8 leading-relaxed">
              {service.desc}
            </p>

            <h3 className="text-xl font-medium font-display text-black dark:text-white mb-4">What's Included:</h3>
            <ul className="space-y-4 mb-10">
              {service.features.map((feature, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <CheckCircle2 size={20} className="text-[#ff6b2b] flex-shrink-0 mt-0.5" />
                  <span className="text-black/80 dark:text-white/80 dark:text-white/80">{feature}</span>
                </li>
              ))}
            </ul>

            <Link to="/contact" className="btn-primary dark:btn-primary-inv py-4 px-8 text-base w-full md:w-auto justify-center">
              Get Started with {service.title}
            </Link>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#ff6b2b]/20 to-transparent rounded-3xl blur-2xl"></div>
            <img 
              src={service.img} 
              alt={service.imgAlt} 
              className="relative w-full rounded-3xl shadow-2xl border border-black/10 dark:border-white/10 dark:border-white/10"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
